import { DetailsCard, DetailsCardItem } from '@components/detailsCard';
import { BaseLayout } from '@layouts/base';
import { TdsMerchantDetail } from '@root/globalTypes';
import {
  Activity,
  BadgeCheck,
  Building2,
  Calendar,
  CreditCard,
  Fingerprint,
  Globe,
  Hash,
  Landmark,
  MapPin,
  ScanFace,
  ShieldCheck,
  Store,
  Tag,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function TdsMerchantPage({
  tdsMerchant,
  onLinkedMerchantSelect,
}: {
  tdsMerchant: TdsMerchantDetail;
  onLinkedMerchantSelect: (merchantId: string) => void;
}) {
  const { t } = useTranslation('app');
  const { merchant } = tdsMerchant;

  return (
    <BaseLayout isChild title={t('pages.tdsMerchant.title')}>
      <DetailsCard>
        <DetailsCardItem
          icon={<Fingerprint />}
          label={t('table.id')}
          data={tdsMerchant.id}
          column={1}
        />
        <DetailsCardItem
          icon={<Store />}
          label={t('table.name')}
          data={tdsMerchant.name || '-'}
          column={2}
        />
        <DetailsCardItem
          icon={<Activity />}
          label={t('table.status')}
          data={tdsMerchant.active || '-'}
          column={1}
        />
        <DetailsCardItem
          icon={<CreditCard />}
          label={t('table.scheme')}
          data={tdsMerchant.cardtype || '-'}
          column={2}
        />
        <DetailsCardItem
          icon={<Hash />}
          label={t('table.merchantIdentifier')}
          data={tdsMerchant.merchantIdentifier || '-'}
          column={1}
        />
        <DetailsCardItem
          icon={<Hash />}
          label={t('table.acquirerMerchantId')}
          data={tdsMerchant.acquirerMerchantId || '-'}
          column={2}
        />
        <DetailsCardItem
          icon={<Landmark />}
          label={t('table.acquirerId')}
          data={tdsMerchant.acquirerId || '-'}
          column={1}
        />
        <DetailsCardItem
          icon={<Building2 />}
          label={t('table.gatewayId')}
          data={tdsMerchant.gatewayId || '-'}
          column={2}
        />
        <DetailsCardItem
          icon={<MapPin />}
          label={t('table.country')}
          data={tdsMerchant.merchantCountryCode || '-'}
          column={1}
        />
        <DetailsCardItem
          icon={<Tag />}
          label={t('table.mcc')}
          data={tdsMerchant.mcc || '-'}
          column={2}
        />
        <DetailsCardItem
          icon={<ScanFace />}
          label={t('table.threeDsRequestorId')}
          data={tdsMerchant.threeDsRequestorId || '-'}
          column={1}
        />
        <DetailsCardItem
          icon={<ScanFace />}
          label={t('table.threeDsRequestorName')}
          data={tdsMerchant.threeDsRequestorName || '-'}
          column={2}
        />
        <DetailsCardItem
          icon={<Globe />}
          label={t('table.website')}
          data={tdsMerchant.threeDsRequestorUrl || '-'}
          column={1}
        />
        <DetailsCardItem
          icon={<ShieldCheck />}
          label={t('table.enrolled')}
          data={tdsMerchant.enrolled || '-'}
          column={2}
        />
        <DetailsCardItem
          icon={<ShieldCheck />}
          label={t('table.enrolledDesc')}
          data={tdsMerchant.enrolledDesc || '-'}
          column={1}
        />
        <DetailsCardItem
          icon={<Calendar />}
          label={t('table.creationDate')}
          data={tdsMerchant.creationDate || '-'}
          column={2}
        />
        <DetailsCardItem
          icon={<BadgeCheck />}
          label={t('table.linkedMerchant')}
          data={
            merchant ? (
              <button
                type="button"
                className="text-primary underline"
                onClick={() => onLinkedMerchantSelect(merchant.merchantId)}>
                {merchant.name}
              </button>
            ) : (
              t('table.notLinked')
            )
          }
          column={1}
        />
      </DetailsCard>
    </BaseLayout>
  );
}
